<script>
// NOTICE: KAPTION-INTEGRATION
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import SettingsLayout from '../SettingsLayout.vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import KaptionResponsePolicyForm from './KaptionResponsePolicyForm.vue';

export default {
  components: {
    SettingsLayout,
    BaseSettingsHeader,
    KaptionResponsePolicyForm,
  },
  computed: {
    ...mapGetters({
      uiFlags: 'kaptionResponsePolicies/getUIFlags',
      getPolicy: 'kaptionResponsePolicies/getPolicy',
    }),
    policyId() {
      return this.$route.params.policyId;
    },
    policy() {
      return this.getPolicy(this.policyId);
    },
  },
  mounted() {
    this.$store.dispatch('kaptionResponsePolicies/get');
  },
  methods: {
    async handleSubmit(data) {
      try {
        await this.$store.dispatch('kaptionResponsePolicies/update', {
          id: this.policyId,
          ...data,
        });
        useAlert(this.$t('KAPTION_RESPONSE_POLICIES.EDIT.API.SUCCESS_MESSAGE'));
        this.$router.push({
          name: 'settings_kaption_response_policies',
        });
      } catch (error) {
        useAlert(this.$t('KAPTION_RESPONSE_POLICIES.EDIT.API.ERROR_MESSAGE'));
      }
    },
    handleCancel() {
      this.$router.push({
        name: 'settings_kaption_response_policies',
      });
    },
  },
};
</script>

<template>
  <SettingsLayout>
    <template #header>
      <BaseSettingsHeader
        :title="$t('KAPTION_RESPONSE_POLICIES.EDIT.TITLE')"
        :back-url="{
          name: 'settings_kaption_response_policies',
        }"
      />
    </template>
    <template #body>
      <div class="mx-auto max-w-lg">
        <KaptionResponsePolicyForm
          v-if="policy"
          :policy="policy"
          :is-submitting="uiFlags.updatingItem"
          :submit-label="$t('KAPTION_RESPONSE_POLICIES.FORM.UPDATE')"
          @submit="handleSubmit"
          @cancel="handleCancel"
        />
      </div>
    </template>
  </SettingsLayout>
</template>
